/// <reference path="wpt.ts" />
/// <reference path="obhelpersActions.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Utilities;
    (function (Utilities) {
        const LOG_CATEGORY = "WPT.OBHelper";
        Utilities.REQUIRED_DOCS_DEFAULT_GROUP = "![[##DEFAULT_GROUP##]]"; // '!' Ensures sorting at the start of each widget
        Utilities.KW_NAME_DOC_TYPE = ">>DocumentType";
        Utilities.KW_NAME_DOC_DATE = ">>DocumentDate";
        /**
         * Functions to assist with manipulating OB objects
         * Will need to see the wpt.config.d.ts
         */
        class OnBaseHelper {
            constructor(core) {
                this.ActionHelper = null;
                this._log = null;
                this._cachePreload = [];
                // Doc type alias translation
                this._docTypeAliases = {};
                this._dtAliasDefaultPolicy = null;
                // Configuration cache ===================================================
                // Keyword Types
                this._ccKeywordTypes = [];
                this._ccKeywordTypeNames = [];
                this._ccKeywordTypeMap = {};
                this._ccKeywordRecordTypes = [];
                this._ccKeywordRecordTypeNames = [];
                this._ccKeywordRecordTypeMap = {};
                this._ccKeywordTypesRequested = false;
                this._ccKeywordRecordsRequested = false;
                this._ccKeywordTypesLoaded = false;
                this._ccKeywordRecordTypesLoaded = false;
                this._ccKeywordTypesCallbacks = [];
                // Document Types (and groups)
                this._ccDocumentTypesById = {};
                this._ccDownloadDocumentTypes = [];
                this._ccDownloadDocumentTypeMap = {};
                this._ccUploadDocumentTypes = [];
                this._ccUploadDocumentTypeMap = {};
                this._ccDownloadDocumentTypeNames = [];
                this._ccUploadDocumentTypeNames = [];
                this._ccDownloadDocumentTypeGroups = [];
                this._ccUploadDocumentTypeGroups = [];
                this._ccDownloadDocumentTypeGroupNames = [];
                this._ccUploadDocumentTypeGroupNames = [];
                this._ccDownloadDocumentTypesRequested = false;
                this._ccUploadDocumentTypesRequested = false;
                this._ccDownloadDocumentTypesLoaded = false;
                this._ccUploadDocumentTypesLoaded = false;
                this._ccAllDocumentTypesCallbacks = [];
                this._ccDownloadDocumentTypesCallbacks = [];
                this._ccUploadDocumentTypesCallbacks = [];
                // Custom Queries
                this._ccQueries = [];
                this._ccQueryNames = [];
                this._ccQueryMap = {};
                this._ccQueriesRequested = false;
                this._ccQueriesLoaded = false;
                this._ccQueriesCallbacks = [];
                // Note Types
                this._ccNoteTypes = [];
                this._ccNoteTypeNames = [];
                this._ccNoteTypesRequested = false;
                this._ccNoteTypesLoaded = false;
                this._ccNoteTypesCallbacks = [];
                // Workflow Entities
                this._ccQueues = [];
                this._ccQueueActions = [];
                this._ccQueueLifecycles = [];
                this._ccQueuesRequested = false;
                this._ccQueuesLoaded = false;
                this._ccQueuesCallbacks = [];
                // Pseudo system tasks
                this._ccPSysTasks = [];
                this._ccPSysTaskMap = {};
                this._ccPSysTasksRequested = false;
                this._ccPSysTasksLoaded = false;
                this._ccPSysTasksCallbacks = [];
                // WorkView entities
                this._ccWVDatasets = [];
                this._ccWVActions = [];
                this._ccWorkViewRequested = false;
                this._ccWorkViewLoaded = false;
                this._ccWorkViewCallbacks = [];
                // Required Documents ===================================================
                // Config
                this._rdFunctionsEnabled = false;
                this._rdDynamicMode = false; // Prevents caching of all profiles to cope with hight volumes
                // Data
                this._rdProfiles = {};
                this._rdRequiredDocumentsLoaded = false;
                this._rdRequiredDocumentsRequested = false;
                this._rdRequiredDocumentsCallbacks = [];
                this.init = () => {
                    this._log.info("OnBaseHelper.init()");
                    // We will want to reload the cache in the case of user changes
                    this._ccKeywordTypesLoaded = false;
                    this._ccKeywordTypesRequested = false;
                    this._ccKeywordRecordsRequested = false;
                    this._ccDocumentTypesById = {};
                    this._ccDownloadDocumentTypesLoaded = false;
                    this._ccUploadDocumentTypesLoaded = false;
                    this._ccDownloadDocumentTypesRequested = false;
                    this._ccUploadDocumentTypesRequested = false;
                    this._ccQueriesLoaded = false;
                    this._ccQueriesRequested = false;
                    this._ccNoteTypesLoaded = false;
                    this._ccNoteTypesRequested = false;
                    this._ccQueuesLoaded = false;
                    this._ccQueuesRequested = false;
                    this._rdRequiredDocumentsLoaded = false;
                    this._rdRequiredDocumentsRequested = false;
                    this._ccPSysTasksLoaded = false;
                    this._ccPSysTasksRequested = false;
                    this._ccWorkViewLoaded = false;
                    this._ccWorkViewRequested = false;
                    this._loadDocTypeAliases();
                    let gwConfig = this._core.Config.getMainConfig();
                    if (gwConfig.hasOwnProperty('OnBaseCachePreload') && (gwConfig.OnBaseCachePreload != null))
                        this._cachePreload = gwConfig.OnBaseCachePreload;
                    let appConfig = this._core.Config.getApplicationConfig();
                    // Required document settings
                    if (appConfig.hasOwnProperty('RequiredDocuments') && appConfig.RequiredDocuments) {
                        if (appConfig.RequiredDocuments.hasOwnProperty('Enabled') && appConfig.RequiredDocuments.Enabled) {
                            this._rdFunctionsEnabled = true;
                            if (appConfig.RequiredDocuments.hasOwnProperty('DynamicSelection') && appConfig.RequiredDocuments.DynamicSelection)
                                this._rdDynamicMode = true;
                        }
                    }
                };
                this.PreloadCache = () => {
                    this._log.info("OnBaseHelper.PreloadCache()");
                    if (!this._core.getCurrentConnectionId())
                        return;
                    // Several reasons to launch the preloads
                    if ((this._doPreload('KeywordTypes') || (this._ccKeywordTypesCallbacks.length > 0)) && !this._ccKeywordTypesRequested)
                        this.LoadKeywordTypes(null);
                    if ((this._doPreload('DocumentTypes') || (this._ccAllDocumentTypesCallbacks.length > 0)) && !this._ccDownloadDocumentTypesRequested && !this._ccUploadDocumentTypesRequested)
                        this.LoadAllDocumentTypes(null);
                    if (this._ccDownloadDocumentTypesCallbacks.length > 0 && !this._ccDownloadDocumentTypesRequested)
                        this.LoadDownloadDocumentTypes(null);
                    if (this._ccUploadDocumentTypesCallbacks.length > 0 && !this._ccUploadDocumentTypesRequested)
                        this.LoadUploadDocumentTypes(null);
                    if ((this._doPreload('CustomQueries') || (this._ccQueriesCallbacks.length > 0)) && !this._ccQueriesRequested)
                        this.LoadCustomQueries(null);
                    if ((this._doPreload('NoteTypes') || (this._ccNoteTypesCallbacks.length > 0)) && !this._ccNoteTypesRequested)
                        this.LoadNoteTypes(null);
                    if ((this._doPreload('Queues') || (this._ccQueuesCallbacks.length > 0)) && !this._ccQueuesRequested)
                        this.LoadQueues(null);
                    if ((this._doPreload('PseudoSystemTasks') || (this._ccPSysTasksCallbacks.length > 0)) && !this._ccPSysTasksRequested)
                        this.LoadPseudoSystemTasks(null);
                    if ((this._doPreload('RequiredDocuments') || (this._rdRequiredDocumentsCallbacks.length > 0)) && !this._rdRequiredDocumentsRequested)
                        this.LoadRequiredDocuments(null);
                    if ((this._doPreload('WorkView') || (this._ccWorkViewCallbacks.length > 0)) && !this._ccWorkViewRequested)
                        this.LoadWorkViewOverview(null);
                };
                this._doPreload = (target) => {
                    if (this._cachePreload.indexOf('*') > -1)
                        return true;
                    if (this._cachePreload.indexOf(target) > -1)
                        return true;
                    return false;
                };
                // ================================================================================= Keyword Query String Filters
                // Converts config file query definition to executable flexsearch including expanding value macros
                this.compileFlexSearchFromQueryDef = (queryConfig, applyOrToSameType = false) => {
                    this._log.info("OnBaseHelper.compileFlexSearchFromQueryDef()");
                    // We likely have a custom query for this call - switch to doc type later if requested
                    let searchDef = { Type: 'customquery', Terms: [] };
                    let result = { SearchDefinition: searchDef, SuppressKeywords: false, MaxHits: 0 };
                    if (typeof queryConfig !== 'object') {
                        searchDef.Terms.push({ Term: '>>customquery', Value: queryConfig });
                    }
                    else {
                        if (queryConfig.hasOwnProperty('QueryType') && queryConfig.QueryType)
                            searchDef.Type = queryConfig.QueryType.toLowerCase();
                        if (searchDef.Type == 'customquery') {
                            if (queryConfig.hasOwnProperty('Name') && queryConfig.Name) {
                                searchDef.Terms.push({ Term: '>>customquery', Value: queryConfig.Name });
                                // Custom queries by default only get column data back
                                if (queryConfig.hasOwnProperty('ForceKeywordPopulation') && (queryConfig.ForceKeywordPopulation != null))
                                    result.SuppressKeywords = !queryConfig.ForceKeywordPopulation;
                                else
                                    result.SuppressKeywords = true;
                            }
                            else {
                                console.warn("Misconfigured query definition encountered - customquery type without 'Name' defined");
                                return null;
                            }
                        }
                        if ((searchDef.Type == 'bydocumenttype') && queryConfig.hasOwnProperty('DocTypes') && queryConfig.DocTypes) {
                            queryConfig.DocTypes.forEach(dtName => {
                                searchDef.Terms.push({ Term: '>>documenttype', Value: dtName });
                            });
                        }
                        if (queryConfig.hasOwnProperty('Keywords') && (queryConfig.Keywords != null) && (queryConfig.Keywords.length > 0)) {
                            // Need to count instances first (don't actually iterate unless the setting is enabled)
                            let keywordsEncountered = [];
                            let keywordsMultiple = [];
                            if (applyOrToSameType) {
                                queryConfig.Keywords.forEach(configKeyword => {
                                    if (keywordsEncountered.indexOf(configKeyword.Name) != -1)
                                        keywordsMultiple.push(configKeyword.Name);
                                    else
                                        keywordsEncountered.push(configKeyword.Name);
                                });
                            }
                            // Now update query with each keyword
                            queryConfig.Keywords.forEach(configKeyword => {
                                // Check for querystring keyword filters
                                let filteredResult = this._getFilterValue(configKeyword);
                                if (applyOrToSameType && (keywordsMultiple.indexOf(configKeyword.Name) > -1)) {
                                    filteredResult.forEach(rk => { rk.Operator = 'or'; });
                                }
                                // Now we can create the object and push it to the list
                                if (filteredResult.length > 0) {
                                    if (configKeyword.hasOwnProperty('Operator') && configKeyword.Operator) {
                                        let operator = configKeyword.Operator.toLowerCase();
                                        filteredResult.forEach(rk => { rk.Operator = operator; });
                                    }
                                    if (configKeyword.hasOwnProperty('Relation') && configKeyword.Relation) {
                                        let relation = configKeyword.Relation.toLowerCase();
                                        filteredResult.forEach(rk => { rk.Relation = relation; });
                                    }
                                    filteredResult.forEach(rk => {
                                        let term = { Term: rk.Name, Value: rk.Value };
                                        if (rk.Operator)
                                            term.Operator = rk.Operator;
                                        if (rk.Relation)
                                            term.Relation = rk.Relation;
                                        searchDef.Terms.push(term);
                                    });
                                }
                            });
                        }
                        if (queryConfig.hasOwnProperty('HistoryLimitDays') && (queryConfig.HistoryLimitDays > 0)) {
                            let limitMilliseconds = queryConfig.HistoryLimitDays * 86400000;
                            let startDateMilliseconds = Date.now() - limitMilliseconds;
                            searchDef.Terms.push({ Term: '>>DateFrom', Value: this._core.Functions.dateNumberToTransportFormat(startDateMilliseconds) });
                            searchDef.Terms.push({ Term: '>>DateTo', Value: this._core.Functions.dateNumberToTransportFormat(Date.now()) });
                        }
                    }
                    return result;
                };
                // Converts an old-style JSON query definition to a flex search, RETAINING value macros
                this.queryDefToStoredFlexSearch = (queryConfig) => {
                    this._log.info("OnBaseHelper.queryDefToStoredFlexSearch()");
                    // We likely have a custom query for this call - switch to doc type later if requested
                    let searchDef = { Type: 'customquery', Terms: [] };
                    if (typeof queryConfig !== 'object') {
                        searchDef.Terms.push({ Term: '>>customquery', Value: queryConfig });
                    }
                    else {
                        if (queryConfig.hasOwnProperty('QueryType') && queryConfig.QueryType)
                            searchDef.Type = queryConfig.QueryType.toLowerCase();
                        if (searchDef.Type == 'customquery') {
                            if (queryConfig.hasOwnProperty('Name') && queryConfig.Name) {
                                searchDef.Terms.push({ Term: '>>customquery', Value: queryConfig.Name });
                            }
                            else {
                                console.warn("Misconfigured query definition encountered - customquery type without 'Name' defined");
                                return null;
                            }
                        }
                        if ((searchDef.Type == 'bydocumenttype') && queryConfig.hasOwnProperty('DocTypes') && queryConfig.DocTypes) {
                            queryConfig.DocTypes.forEach(dtName => {
                                searchDef.Terms.push({ Term: '>>documenttype', Value: dtName });
                            });
                        }
                        if (queryConfig.hasOwnProperty('Keywords') && (queryConfig.Keywords != null) && (queryConfig.Keywords.length > 0)) {
                            // Now update query with each keyword
                            queryConfig.Keywords.forEach(configKeyword => {
                                let term = { Term: configKeyword.Name, Value: configKeyword.Value };
                                if (configKeyword.Operator)
                                    term.Operator = configKeyword.Operator.toLowerCase();
                                if (configKeyword.Relation)
                                    term.Relation = configKeyword.Relation.toLowerCase();
                                searchDef.Terms.push(term);
                            });
                        }
                        if (queryConfig.hasOwnProperty('HistoryLimitDays') && (queryConfig.HistoryLimitDays > 0)) {
                            let limitMilliseconds = queryConfig.HistoryLimitDays * 86400000;
                            let startDateMilliseconds = Date.now() - limitMilliseconds;
                            searchDef.Terms.push({ Term: '>>DateFrom', Value: this._core.Functions.dateNumberToTransportFormat(startDateMilliseconds) });
                            searchDef.Terms.push({ Term: '>>DateTo', Value: this._core.Functions.dateNumberToTransportFormat(Date.now()) });
                        }
                    }
                    return searchDef;
                };
                // Takes a basic flexSearch and expands any value definition macros so the search can be executed
                this.flexDefinitionToRequest = (sourceDef, applyOrToSameType = false) => {
                    this._log.info("OnBaseHelper.flexDefinitionToRequest()");
                    // We likely have a custom query for this call - switch to doc type later if requested
                    let searchDef = { Type: sourceDef.Type, Terms: [] };
                    let result = { SearchDefinition: searchDef, SuppressKeywords: false, MaxHits: 0 };
                    sourceDef.Terms.forEach(sourceTerm => {
                        if (sourceTerm.Term.startsWith('>>')) {
                            let instances = this._core.Context.expandMacro(sourceTerm.Value);
                            if (instances.length > 0) {
                                searchDef.Terms.push({ Term: sourceTerm.Term, Operator: sourceTerm.Operator, Relation: sourceTerm.Relation, Grouping: sourceTerm.Grouping, Value: instances[0] });
                            }
                            else
                                searchDef.Terms.push(sourceTerm);
                        }
                        else {
                            let instances = this._core.Context.expandMacro(sourceTerm.Value);
                            let multiple = (instances.length > 1);
                            instances.forEach(instance => {
                                let entry = { Term: sourceTerm.Term, Value: instance };
                                if (sourceTerm.hasOwnProperty('Operator'))
                                    entry.Operator = sourceTerm.Operator;
                                else
                                    entry.Operator = (applyOrToSameType && multiple) ? 'or' : 'and';
                                if (sourceTerm.hasOwnProperty('Relation'))
                                    entry.Relation = sourceTerm.Relation;
                                else
                                    sourceTerm.Relation = '=';
                                searchDef.Terms.push(entry);
                            });
                        }
                    });
                    return result;
                };
                this.expandWorkViewConstraintMacros = (constraints) => {
                    this._log.info("OnBaseHelper.addWorkViewFilterConstraints()");
                    let result = [];
                    constraints.forEach(constraint => {
                        let instances = this._core.Context.expandMacro(constraint.Value);
                        let instancesLength = instances.length;
                        for (let i = 0; i < instancesLength; i++) {
                            let instance = instances[i];
                            let entry = { Term: constraint.Term, Value: instance };
                            if (constraint.hasOwnProperty('Relation'))
                                entry.Relation = constraint.Relation;
                            if (constraint.hasOwnProperty('Operator'))
                                entry.Operator = constraint.Operator;
                            else
                                entry.Operator = (instancesLength > 1) ? 'or' : 'and';
                            if (constraint.hasOwnProperty('Grouping')) {
                                if ((constraint.Grouping == "(" && i == 0) || (constraint.Grouping == ")" && i == (instancesLength - 1))) {
                                    entry.Grouping = constraint.Grouping;
                                }
                            }
                            result.push(entry);
                        }
                    });
                    return result;
                };
                this.filterDocumentList = (srcList, filters, primaryDoc = null) => {
                    this._log.info("OnBaseHelper.filterDocumentList()");
                    // Sanity checking - don't filter if no filters
                    if (!filters || (filters.length == 0))
                        return srcList;
                    // Filters may need to be pulled from environment/parent doc
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("populating filters");
                    }
                    let populatedFilters = [];
                    filters.forEach(filter => {
                        // Check for querystring keyword filters
                        let filteredResult = this._getFilterValue(filter);
                        // Now we can create the object and push it to the list
                        if (filteredResult.length > 0)
                            populatedFilters.push(...filteredResult);
                    });
                    // May still end up with no viable filters
                    if (populatedFilters.length == 0)
                        return srcList;
                    // If we get here we have at least one filter we need to apply
                    // Need a hit map - which we wil reuse
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("creating hitmap");
                    }
                    let hitMap = {};
                    populatedFilters.forEach(filter => {
                        if (filter.Name in hitMap) {
                            if (filter.hasOwnProperty('Operator') && (filter.Operator == 'and'))
                                hitMap[filter.Name].Expected++;
                        }
                        else
                            hitMap[filter.Name] = { Expected: 1, Hits: 0 };
                    });
                    // Loop and test, build destination list
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("starting main filter loop");
                    }
                    let destList = [];
                    srcList.forEach(doc => {
                        populatedFilters.forEach(filter => {
                            // This is horribly ineffient for multiple instances of the same keyword, but hopefully that's an edge case
                            let values = this.GetAllKeywordValues(doc, filter.Name);
                            if (values.indexOf(filter.Value) > -1)
                                hitMap[filter.Name].Hits++;
                        });
                        // Check if all our hits are valid, and clear the hit map for the next run
                        let acceptDoc = true;
                        for (let keyName in hitMap) {
                            if (hitMap[keyName].Expected > hitMap[keyName].Hits)
                                acceptDoc = false;
                            hitMap[keyName].Hits = 0;
                        }
                        if (acceptDoc)
                            destList.push(doc);
                    });
                    // Hand back what we have
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`filterDocumentList returning ${destList.length} documents`);
                    }
                    return destList;
                };
                this._getFilterValue = (filter, applyOrToSameType = false) => {
                    this._log.info("OnBaseHelper._getFilterValue()");
                    if (this._log.isTraceEnabled())
                        this._log.trace(`${filter.Name} -> ${filter.Value}`);
                    let response = [];
                    let instances = this._core.Context.expandMacro(filter.Value);
                    let multiple = (instances.length > 1);
                    instances.forEach(instance => {
                        let keyEntry = { Name: filter.Name, Value: instance };
                        keyEntry.Operator = (applyOrToSameType && multiple) ? 'or' : 'and';
                        response.push(keyEntry);
                    });
                    return response;
                };
                // We do this enough it seems to make sense to push it into on general call
                // Add fail and error optional parameters as the app context object needs to respond to failures
                this.GetDocumentMetadata = (handle, callback, errorCallback, failCallback) => {
                    this._log.info("OnBaseHelper.GetDocumentMetadata()");
                    let ecb = (errorCallback) ? errorCallback : this._cacheCallErrorHandler;
                    let fcb = (failCallback) ? failCallback : this._cacheCallFailedHandler;
                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetDocument/${handle}`, this._gotDocumentMetadata.bind(this, callback), ecb, fcb);
                };
                this._gotDocumentMetadata = (callback, response) => {
                    this._log.info("OnBaseHelper._gotDocumentMetadata()");
                    if (response.hasOwnProperty('Documents') && response.Documents && response.Documents.length > 0) {
                        callback(response.Documents[0]);
                    }
                    else {
                        callback(null);
                    }
                };
                this.GetKeywordDataSet = (typeName) => {
                    this._log.info("OnBaseHelper.GetKeywordDataSet()");
                    if (typeName in this._ccKeywordTypeMap) {
                        if ((this._ccKeywordTypeMap[typeName].hasOwnProperty('DataSet')) && (this._ccKeywordTypeMap[typeName].DataSet != null))
                            return this._ccKeywordTypeMap[typeName].DataSet;
                        else
                            return null;
                    }
                    else {
                        console.warn(`getKeywordDataSet: Request for unrecognised keyword type '${typeName}'`);
                        return null;
                    }
                };
                this.LoadKeywordTypes = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadKeywordTypes()");
                    if (this.KeywordTypesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccKeywordTypesCallbacks.push(callback);
                    if (!this._ccKeywordTypesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetKeywordListWithConfig', this._keywordTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccKeywordTypesRequested = true;
                    }
                    if (!this._ccKeywordRecordsRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetKeywordRecordList', this._keywordRecordTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccKeywordRecordsRequested = true;
                    }
                };
                this._keywordTypesReceived = (response) => {
                    this._log.info("OnBaseHelper._keywordTypesReceived()");
                    this._ccKeywordTypes = [];
                    this._ccKeywordTypeNames = [];
                    this._ccKeywordTypeMap = {};
                    if (response.hasOwnProperty('KeywordTypes') && (response.KeywordTypes != null)) {
                        this._ccKeywordTypes = response.KeywordTypes;
                        this._ccKeywordTypes.forEach(kt => {
                            this._ccKeywordTypeNames.push(kt.Name);
                            this._ccKeywordTypeMap[kt.Name] = kt;
                        });
                    }
                    // Pseudo-keyword types to make keyword handling easier
                    // NOTE: >>DateSingle needs special handing before passing into queries as it needs to be a DateFrom/DateTo combination eventually.
                    let docDate = { Id: -1, Name: ">>DocumentDate", TranslatedName: this._core.Locale.getTranslation("STR_WPT_DOCDATE"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let dateFrom = { Id: -2, Name: ">>DateFrom", TranslatedName: this._core.Locale.getTranslation("STR_WPT_SEARCH_DATE_FROM"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let dateTo = { Id: -3, Name: ">>DateTo", TranslatedName: this._core.Locale.getTranslation("STR_WPT_SEARCH_DATE_TO"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let dateSingle = { Id: -4, Name: ">>DateSingle", TranslatedName: this._core.Locale.getTranslation("STR_WPT_SEARCH_DATE"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let docHandle = { Id: -5, Name: ">>DocumentHandle", TranslatedName: this._core.Locale.getTranslation("STR_WPT_DOCHANDLE"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let docTitle = { Id: -6, Name: ">>DocumentTitle", TranslatedName: this._core.Locale.getTranslation("STR_WPT_DOC_TITLE"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let revCount = { Id: -7, Name: ">>RevisionCount", TranslatedName: this._core.Locale.getTranslation("STR_WPT_REVISION_COUNT"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let docType = { Id: -8, Name: ">>DocumentType", TranslatedName: this._core.Locale.getTranslation("STR_WPT_DOCTYPE"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    let createdBy = { Id: -9, Name: ">>CreatedBy", TranslatedName: this._core.Locale.getTranslation("STR_WPT_CREATED_BY"), Type: "Date", Length: 0, CaseSensitive: false, AutofillKeywordSetId: 0, MustExistInDataset: false };
                    this._ccKeywordTypes.push(docDate, dateFrom, dateTo, docHandle, docTitle, revCount, docType, createdBy);
                    this._ccKeywordTypeNames.push(">>DocumentDate", ">>DateFrom", ">>DateTo", ">>DateSingle", ">>DocumentHandle", ">>DocumentTitle", ">>RevisionCount", ">>DocumentType", ">>CreatedBy");
                    this._ccKeywordTypeMap[">>DocumentDate"] = docDate;
                    this._ccKeywordTypeMap[">>DateFrom"] = dateFrom;
                    this._ccKeywordTypeMap[">>DateTo"] = dateTo;
                    this._ccKeywordTypeMap[">>DateSingle"] = dateSingle;
                    this._ccKeywordTypeMap[">>DocumentHandle"] = docHandle;
                    this._ccKeywordTypeMap[">>DocumentTitle"] = docTitle;
                    this._ccKeywordTypeMap[">>RevisionCount"] = revCount;
                    this._ccKeywordTypeMap[">>DocumentType"] = docType;
                    this._ccKeywordTypeMap[">>CreatedBy"] = createdBy;
                    this._ccKeywordTypesLoaded = true;
                    // Throw callbacks
                    if (this.KeywordTypesLoaded) {
                        this._ccKeywordTypesCallbacks.forEach(callback => { callback(); });
                        this._ccKeywordTypesCallbacks = [];
                    }
                };
                this._keywordRecordTypesReceived = (response) => {
                    this._log.info("OnBaseHelper._keywordRecordTypesReceived()");
                    this._ccKeywordRecordTypes = [];
                    this._ccKeywordRecordTypeNames = [];
                    this._ccKeywordRecordTypeMap = {};
                    if (response.hasOwnProperty('KeywordRecordTypes') && (response.KeywordRecordTypes != null)) {
                        this._ccKeywordRecordTypes = response.KeywordRecordTypes;
                        this._ccKeywordRecordTypes.forEach(krt => {
                            this._ccKeywordRecordTypeNames.push(krt.Name);
                            this._ccKeywordRecordTypeMap[krt.Name] = krt;
                        });
                    }
                    this._ccKeywordRecordTypesLoaded = true;
                    // Throw callbacks
                    if (this.KeywordTypesLoaded) {
                        this._ccKeywordTypesCallbacks.forEach(callback => { callback(); });
                        this._ccKeywordTypesCallbacks = [];
                    }
                };
                this.LoadAllDocumentTypes = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadAllDocumentTypes()");
                    if (this.AllDocumentTypesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccAllDocumentTypesCallbacks.push(callback);
                    if (!this._ccDownloadDocumentTypesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetDocTypeList', this._DownloadDocumentTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccDownloadDocumentTypesRequested = true;
                    }
                    if (!this._ccUploadDocumentTypesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetUploadDocTypeList', this._UploadDocumentTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccUploadDocumentTypesRequested = true;
                    }
                };
                this.LoadDownloadDocumentTypes = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadDownloadDocumentTypes()");
                    if (this._ccDownloadDocumentTypesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccDownloadDocumentTypesCallbacks.push(callback);
                    if (!this._ccDownloadDocumentTypesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetDocTypeList', this._DownloadDocumentTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccDownloadDocumentTypesRequested = true;
                    }
                };
                this.LoadUploadDocumentTypes = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadUploadDocumentTypes()");
                    if (this._ccUploadDocumentTypesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccUploadDocumentTypesCallbacks.push(callback);
                    if (!this._ccUploadDocumentTypesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetUploadDocTypeList', this._UploadDocumentTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccUploadDocumentTypesRequested = true;
                    }
                };
                this._DownloadDocumentTypesReceived = (response) => {
                    this._log.info("OnBaseHelper._DownloadDocumentTypesReceived()");
                    this._ccDownloadDocumentTypes = [];
                    this._ccDownloadDocumentTypeMap = {};
                    this._ccDownloadDocumentTypeNames = [];
                    this._ccDownloadDocumentTypeGroups = [];
                    this._ccDownloadDocumentTypeGroupNames = [];
                    if (response.hasOwnProperty('DocTypes') && (response.DocTypes != null)) {
                        this._ccDownloadDocumentTypes = response.DocTypes;
                        this._ccDownloadDocumentTypes.forEach(dt => {
                            this._ccDownloadDocumentTypeNames.push(dt.Name);
                            this._ccDownloadDocumentTypeMap[dt.Name] = dt;
                            this._ccDocumentTypesById[dt.Id] = dt;
                        });
                    }
                    if (response.hasOwnProperty('Groups') && (response.Groups != null)) {
                        this._ccDownloadDocumentTypeGroups = response.Groups;
                        this._ccDownloadDocumentTypeGroups.forEach(dtg => {
                            this._ccDownloadDocumentTypeGroupNames.push(dtg.Name);
                        });
                    }
                    this._ccDownloadDocumentTypesLoaded = true;
                    // Throw callbacks for download doc type sets received
                    this._ccDownloadDocumentTypesCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccDownloadDocumentTypesCallbacks = [];
                    // Throw callbacks if both doc type sets received
                    if (this._ccUploadDocumentTypesLoaded) {
                        this._ccAllDocumentTypesCallbacks.forEach(callback => {
                            callback();
                        });
                        this._ccAllDocumentTypesCallbacks = [];
                    }
                };
                this._UploadDocumentTypesReceived = (response) => {
                    this._log.info("OnBaseHelper._UploadDocumentTypesReceived()");
                    this._ccUploadDocumentTypes = [];
                    this._ccUploadDocumentTypeMap = {};
                    this._ccUploadDocumentTypeNames = [];
                    this._ccUploadDocumentTypeGroups = [];
                    this._ccUploadDocumentTypeGroupNames = [];
                    if (response.hasOwnProperty('DocTypes') && (response.DocTypes != null)) {
                        this._ccUploadDocumentTypes = response.DocTypes;
                        this._ccUploadDocumentTypes.forEach(dt => {
                            this._ccUploadDocumentTypeNames.push(dt.Name);
                            this._ccUploadDocumentTypeMap[dt.Name] = dt;
                            this._ccDocumentTypesById[dt.Id] = dt;
                        });
                    }
                    if (response.hasOwnProperty('Groups') && (response.Groups != null)) {
                        this._ccUploadDocumentTypeGroups = response.Groups;
                        this._ccUploadDocumentTypeGroups.forEach(dtg => {
                            this._ccUploadDocumentTypeGroupNames.push(dtg.Name);
                        });
                    }
                    this._ccUploadDocumentTypesLoaded = true;
                    // Throw callbacks for upload doc type sets received
                    this._ccUploadDocumentTypesCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccUploadDocumentTypesCallbacks = [];
                    // Throw callbacks if both doc type sets received
                    if (this._ccDownloadDocumentTypesLoaded) {
                        this._ccAllDocumentTypesCallbacks.forEach(callback => {
                            callback();
                        });
                        this._ccAllDocumentTypesCallbacks = [];
                    }
                };
                this.DocTypeHasKeywordType = (docTypeName, keyTypeName) => {
                    this._log.info("OnBaseHelper.DocTypeHasKeywordType()");
                    if (docTypeName in this._ccDownloadDocumentTypeMap) {
                        let docType = this._ccDownloadDocumentTypeMap[docTypeName];
                        // Loop with indexers to enable return
                        for (let i = 0; i < docType.KeywordRecords.length; i++) {
                            let kwr = docType.KeywordRecords[i];
                            for (let j = 0; j < kwr.KeywordTypes.length; j++) {
                                // Filter not only on the document type, but ensure the keyword is one we recognise
                                if ((kwr.KeywordTypes[j].Name == keyTypeName) && (this._ccKeywordTypeNames.indexOf(keyTypeName) > -1))
                                    return true;
                            }
                        }
                    }
                    return false;
                };
                this.LoadCustomQueries = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadCustomQueries()");
                    if (this._ccQueriesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccQueriesCallbacks.push(callback);
                    if (!this._ccQueriesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetQueryList', this._queriesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccQueriesRequested = true;
                    }
                };
                this._queriesReceived = (response) => {
                    this._log.info("OnBaseHelper._queriesReceived()");
                    this._ccQueries = [];
                    this._ccQueryNames = [];
                    this._ccQueryMap = {};
                    if ((response.hasOwnProperty('Queries')) && response.Queries && (response.Queries.length > 0)) {
                        this._ccQueries = response.Queries;
                        this._ccQueries.forEach(q => {
                            // Default date range to null so we can pull default further down the widget chain
                            if (!q.hasOwnProperty('DateEntry'))
                                q.DateEntry = null;
                            if (!q.hasOwnProperty('Label') || !q.Label)
                                q.Label = q.Name;
                            else
                                q.Label = this._core.Locale.getTranslation(q.Label);
                            this._ccQueryNames.push(q.Name);
                            this._ccQueryMap[q.Name] = q;
                        });
                    }
                    this._ccQueriesLoaded = true;
                    // Throw callbacks
                    this._ccQueriesCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccQueriesCallbacks = [];
                };
                this.LoadNoteTypes = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadNoteTypes()");
                    if (this._ccNoteTypesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccNoteTypesCallbacks.push(callback);
                    if (!this._ccNoteTypesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Config.svc/rest/GetNoteList', this._noteTypesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccNoteTypesRequested = true;
                    }
                };
                this._noteTypesReceived = (response) => {
                    this._log.info("OnBaseHelper._noteTypesReceived()");
                    this._ccNoteTypes = [];
                    this._ccNoteTypeNames = [];
                    if (response.hasOwnProperty('Notes') && (response.Notes != null)) {
                        this._ccNoteTypes = response.Notes;
                        this._ccNoteTypes.forEach(nt => {
                            this._ccNoteTypeNames.push(nt.Type);
                        });
                    }
                    this._ccNoteTypesLoaded = true;
                    // Throw callbacks
                    this._ccNoteTypesCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccNoteTypesCallbacks = [];
                };
                this.LoadQueues = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadQueues()");
                    if (this._ccQueuesLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccQueuesCallbacks.push(callback);
                    if (!this._ccQueuesRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Workflow.svc/rest/GetMyWorkflowOverview', this._queuesReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccQueuesRequested = true;
                    }
                };
                this._queuesReceived = (response) => {
                    this._log.info("OnBaseHelper._queuesReceived()");
                    this._ccQueues = [];
                    this._ccQueueActions = [];
                    this._ccQueueLifecycles = [];
                    if (response.hasOwnProperty('Workflows') && (response.Workflows != null)) {
                        this._ccQueues = response.Workflows;
                        response.Workflows.forEach(q => {
                            if (q.hasOwnProperty('Actions') && q.Actions != null) {
                                q.Actions.forEach(a => {
                                    this._ccQueueActions.push(a);
                                });
                            }
                            if (q.hasOwnProperty('LifeCycle') && q.LifeCycle != null) {
                                let existing = this._ccQueueLifecycles.find(lc => lc.Id == q.LifeCycle.Id);
                                if (!existing)
                                    this._ccQueueLifecycles.push(q.LifeCycle);
                            }
                        });
                    }
                    this._ccQueuesLoaded = true;
                    // Throw callbacks
                    this._ccQueuesCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccQueuesCallbacks = [];
                };
                this.LoadPseudoSystemTasks = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadPseudoSystemTasks()");
                    if (this._ccPSysTasksLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccPSysTasksCallbacks.push(callback);
                    if (!this._ccPSysTasksRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/Workflow.svc/rest/GetPseudoSystemTasks', this._pseudoSystemTasksReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccPSysTasksRequested = true;
                    }
                };
                this._pseudoSystemTasksReceived = (response) => {
                    this._log.info("OnBaseHelper._pseudoSystemTasksReceived()");
                    this._ccPSysTasks = [];
                    this._ccPSysTaskMap = {};
                    if (response.hasOwnProperty('Tasks') && (response.Tasks != null)) {
                        this._ccPSysTasks = response.Tasks;
                        this._ccPSysTasks.forEach(pst => {
                            pst.Label = this._core.Locale.getTranslation(pst.Label);
                            this._ccPSysTaskMap[pst.Identifier] = pst;
                        });
                    }
                    this._ccPSysTasksLoaded = true;
                    // Throw callbacks
                    this._ccPSysTasksCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccPSysTasksCallbacks = [];
                };
                this.LoadWorkViewOverview = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadWorkViewOverview()");
                    if (this._ccWorkViewLoaded && callback) {
                        callback();
                        return;
                    }
                    if (callback)
                        this._ccWorkViewCallbacks.push(callback);
                    if (!this._ccWorkViewRequested && this._core.getCurrentConnectionId()) {
                        this._core.Loader.genericServiceCall('/WorkView.svc/rest/GetMyWorkViewOverview', this._wvOverviewReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._ccWorkViewRequested = true;
                    }
                };
                this._wvOverviewReceived = (response) => {
                    this._log.info("OnBaseHelper._wvOverviewReceived()");
                    this._ccWVDatasets = [];
                    this._ccWVActions = [];
                    if (response.hasOwnProperty('Datasets') && response.Datasets != null && response.Datasets.length > 0) {
                        this._ccWVDatasets = response.Datasets;
                    }
                    if (response.hasOwnProperty('Applications') && response.Applications != null && response.Applications.length > 0) {
                        let instance = this;
                        response.Applications.forEach(app => {
                            app.Classes.forEach(clazz => {
                                clazz.Actions.forEach(action => {
                                    instance._ccWVActions.push({
                                        Application: app.Name,
                                        Class: clazz.Name,
                                        Name: action
                                    });
                                });
                            });
                        });
                    }
                    this._ccWorkViewLoaded = true;
                    // Throw callbacks
                    this._ccWorkViewCallbacks.forEach(callback => {
                        callback();
                    });
                    this._ccWorkViewCallbacks = [];
                };
                this.LoadRequiredDocuments = (callback = null) => {
                    this._log.info("OnBaseHelper.LoadRequiredDocuments()");
                    // Dynamic mode is designed to prevent cache overload - so we definitely don't want to populate the cache!
                    if (!this._rdFunctionsEnabled || this._rdDynamicMode)
                        return;
                    // If docs already loaded, we don't need them
                    if (this._rdRequiredDocumentsLoaded && callback) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("requirement profiles already loaded, firing callback");
                        }
                        callback();
                        return;
                    }
                    if (callback)
                        this._rdRequiredDocumentsCallbacks.push(callback);
                    if (!this._rdRequiredDocumentsRequested && this._core.getCurrentConnectionId()) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("requirement profiles not loaded, requesting");
                        }
                        // Need to pull all the profile documents
                        this._core.Loader.genericServiceCall('/Documents.svc/rest/GetAllRequiredDocProfiles', this._requiredDocumentsReceived, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                        this._rdRequiredDocumentsRequested = true;
                    }
                };
                this._requiredDocumentsReceived = (response) => {
                    this._log.info("OnBaseHelper._requiredDocumentsReceived()");
                    this._rdProfiles = {};
                    if (response.hasOwnProperty('Profiles') && response.Profiles != null) {
                        response.Profiles.forEach(profile => {
                            // Some sanity checking before we store
                            if (profile.Name && (Object.keys(profile.Groups).length > 0) && (profile.AppliesTo.length > 0)) {
                                profile.FlatRequirementMap = {};
                                // Insert into our map
                                profile.AppliesTo.forEach(dtName => {
                                    if (!(dtName in this._rdProfiles))
                                        this._rdProfiles[dtName] = [];
                                    this._rdProfiles[dtName].push(profile);
                                });
                            }
                            else {
                                let message = this._core.Locale.getTranslation('STR_WPT_MISCONFIGURED_DOC_CHECKLIST');
                                this._core.Helper.presentWarningServiceModal("STR_WPT_CONFIG_CACHE", "STR_WPT_ERROR", message);
                            }
                        }); // Foreach document in response
                    }
                    this._rdRequiredDocumentsLoaded = true;
                    // Throw callbacks
                    this._rdRequiredDocumentsCallbacks.forEach(callback => {
                        callback();
                    });
                };
                this.GetProfileDynamic = (docTypeName, contexts, callback) => {
                    this._log.info("OnBaseHelper.GetProfileDynamic()");
                    let request = { MasterDocType: docTypeName, Contexts: contexts };
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/GetRequiredDocProfile', JSON.stringify(request), this._requiredDocsDynamicReceived.bind(this, callback), {}, this._cacheCallErrorHandler, this._cacheCallFailedHandler);
                };
                this._requiredDocsDynamicReceived = (callback, response) => {
                    this._log.info("OnBaseHelper._requiredDocsDynamicReceived()");
                    if (response.hasOwnProperty('Profiles') && (response.Profiles != null) && (response.Profiles.length > 0)) {
                        // Report any weirdness byt carry on regardless
                        if (response.Profiles.length > 1) {
                            console.warn("Required document dynamic query returned multiple profiles - using first");
                        }
                        let profile = response.Profiles[0];
                        profile.FlatRequirementMap = {};
                        if (profile.Name && (Object.keys(profile.Groups).length > 0) && (profile.AppliesTo.length > 0))
                            callback(profile);
                        else
                            callback(null);
                    }
                    else {
                        callback(null);
                    }
                };
                // ================================================================================= Caching Service Call Error Handling
                this._cacheCallFailedHandler = (json) => {
                    this._log.info("OnBaseHelper._cacheCallFailedHandler()");
                    let response = json;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CONFIG_CACHE", "STR_WPT_ERROR", response.Connection.Message);
                };
                this._cacheCallErrorHandler = (url, status, message) => {
                    this._log.info("OnBaseHelper._cacheCallErrorHandler()");
                    let msg = `${status}: ${message} - [${url}]`;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_CONFIG_CACHE", "STR_WPT_ERROR", message);
                };
                this.GetKeywordObject = (doc, keyName, useAliases = true) => {
                    this._log.info("OnBaseHelper.GetKeywordObject()");
                    // Process special cases
                    if (keyName == Utilities.KW_NAME_DOC_TYPE) {
                        if (doc.hasOwnProperty('DocType')) {
                            let obk = { Id: 0, Name: keyName, Type: 'AlphaNumeric', Value: (useAliases)
                                    ? this.getDocTypeAlias(doc.DocType.Name, doc.DocType.TranslatedName) : doc.DocType.TranslatedName };
                            return obk;
                        }
                        else
                            return null;
                    }
                    else if (keyName == Utilities.KW_NAME_DOC_DATE) {
                        if (doc.hasOwnProperty('Date')) {
                            // Don't reformat the date here - need it in serialised format
                            let obk = { Id: 0, Name: keyName, Type: 'Date', Value: doc.Date };
                            return obk;
                        }
                        else
                            return null;
                    }
                    else if (keyName == ">>DocumentTitle") {
                        return { Id: 0, Name: keyName, Type: 'AlphaNumeric', Value: doc.Name };
                    }
                    else if (keyName == ">>DocumentHandle") {
                        return { Id: 0, Name: keyName, Type: 'Numeric20', Value: doc.ItemNum.toString() };
                    }
                    else if (keyName == ">>CreatedBy") {
                        if (doc.CreatedBy)
                            return { Id: 0, Name: keyName, Type: 'AlphaNumeric', Value: doc.CreatedBy };
                        else
                            return null;
                    }
                    else if (keyName == ">>RevisionCount") {
                        return { Id: 0, Name: keyName, Type: 'Numeric9', Value: doc.RevisionCount.toString() };
                    }
                    // If we got here, we're running against normal keywords
                    let key = null;
                    for (let keyRecord of doc.KeywordRecords) {
                        key = keyRecord.Keywords.find(kw => kw.Name == keyName);
                        if (key != null)
                            break;
                    }
                    return key;
                };
                this.GetKeywordValue = (doc, keyName, useAliases = true) => {
                    this._log.info("OnBaseHelper.GetKeywordValue()");
                    // Process special cases
                    if (keyName == Utilities.KW_NAME_DOC_TYPE) {
                        if (doc.hasOwnProperty('DocType')) {
                            return (useAliases) ? this.getDocTypeAlias(doc.DocType.Name, doc.DocType.TranslatedName) : doc.DocType.TranslatedName;
                        }
                        else
                            return null;
                    }
                    else if (keyName == Utilities.KW_NAME_DOC_DATE) {
                        if (doc.hasOwnProperty('Date'))
                            return this.formatDate(doc.Date);
                        else
                            return null;
                    }
                    else if (keyName == ">>DocumentTitle") {
                        return doc.Name;
                    }
                    else if (keyName == ">>DocumentHandle") {
                        return doc.ItemNum.toString();
                    }
                    else if (keyName == ">>CreatedBy") {
                        if (doc.CreatedBy)
                            return doc.CreatedBy;
                        else
                            return null;
                    }
                    else if (keyName == ">>RevisionCount") {
                        return doc.RevisionCount.toString();
                    }
                    // If we got here, we're running against normal keywords - ensure we have an iterable record list
                    if (!doc.hasOwnProperty('KeywordRecords') || (doc.KeywordRecords == null))
                        return null;
                    let key = null;
                    for (let keyRecord of doc.KeywordRecords) {
                        key = keyRecord.Keywords.find(kw => kw.Name == keyName);
                        if (key != null)
                            break;
                    }
                    // We have a key, hopefully
                    if (key != null) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`GetKeywordValue returning ${keyName}='${key.Value}'`);
                        }
                        // Is this missing a cast for DateTime?
                        if (key.Type == "Date")
                            return this.formatDate(key.Value);
                        else
                            return key.Value;
                    }
                    else
                        return null;
                };
                /**
                 * Pulls all defined keywords of a certain type in to an array
                 * Is this missing a cast for DateTime?
                 */
                this.GetAllKeywordValues = (doc, keyName, useAliases = true) => {
                    this._log.info("OnBaseHelper.GetAllKeywordValues()");
                    if (keyName == Utilities.KW_NAME_DOC_TYPE) {
                        if (doc.hasOwnProperty('DocType')) {
                            return (useAliases) ? [this.getDocTypeAlias(doc.DocType.Name, doc.DocType.TranslatedName)] : [doc.DocType.TranslatedName];
                        }
                        else
                            return null;
                    }
                    else if (keyName == Utilities.KW_NAME_DOC_DATE) {
                        if (doc.hasOwnProperty('Date'))
                            return [this.formatDate(doc.Date)];
                        else
                            return null;
                    }
                    else if (keyName == ">>DocumentTitle") {
                        return [doc.Name];
                    }
                    else if (keyName == ">>DocumentHandle") {
                        return [doc.ItemNum.toString()];
                    }
                    else if (keyName == ">>CreatedBy") {
                        if (doc.CreatedBy)
                            return [doc.CreatedBy];
                        else
                            return [];
                    }
                    else if (keyName == ">>RevisionCount") {
                        return [doc.RevisionCount.toString()];
                    }
                    // Jump out if no keyword records
                    if (!doc.hasOwnProperty('KeywordRecords') || (doc.KeywordRecords == null))
                        return [];
                    let keys = [];
                    for (let keyRecord of doc.KeywordRecords) {
                        for (let key of keyRecord.Keywords) {
                            if (key.Name == keyName) {
                                if (key.Type == "Date")
                                    keys.push(this.formatDate(key.Value));
                                else
                                    keys.push(key.Value);
                            }
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`GetAllKeywordValues() returning ${keys.length} instances of keyword ${keyName}`);
                    }
                    return keys;
                };
                /**
                 * Attempt to reduce looping when seeking multiple keywords from the same document.
                 * May not be much faster than multiple calls to GetKeywordValue - still has several lookups
                 * LIMITATION: Will take the first instance of each keyword regardless of records.
                 */
                this.GetMultipleKeywordValues = (doc, keyNames, useAliases = true) => {
                    this._log.info("OnBaseHelper.GetMultipleKeywordValues()");
                    // Setup
                    let result = {};
                    let keysFound = 0;
                    let keysExpected = keyNames.length;
                    // We can get properties too
                    if (keyNames.indexOf(Utilities.KW_NAME_DOC_TYPE) > -1) {
                        if (useAliases)
                            result[Utilities.KW_NAME_DOC_TYPE] = this.getDocTypeAlias(doc.DocType.Name, doc.DocType.TranslatedName);
                        else
                            result[Utilities.KW_NAME_DOC_TYPE] = doc.DocType.TranslatedName;
                    }
                    if (keyNames.indexOf(Utilities.KW_NAME_DOC_DATE) > -1) {
                        if (doc.Date)
                            result[Utilities.KW_NAME_DOC_DATE] = this.formatDate(doc.Date);
                        else
                            result[Utilities.KW_NAME_DOC_DATE] = "";
                    }
                    if (keyNames.indexOf(">>DocumentTitle") > -1) {
                        result[">>DocumentTitle"] = doc.Name;
                    }
                    if (keyNames.indexOf(">>DocumentHandle") > -1) {
                        result[">>DocumentHandle"] = doc.ItemNum.toString();
                    }
                    if (keyNames.indexOf(">>CreatedBy") > -1) {
                        if (doc.CreatedBy)
                            result[">>CreatedBy"] = doc.CreatedBy;
                    }
                    if (keyNames.indexOf(">>RevisionCount") > -1) {
                        result[">>RevisionCount"] = doc.RevisionCount.toString();
                    }
                    // Do our loops
                    // Jump out if no keyword records
                    if (!doc.hasOwnProperty('KeywordRecords') || (doc.KeywordRecords == null))
                        return result;
                    for (let keyRecord of doc.KeywordRecords) {
                        for (let key of keyRecord.Keywords) {
                            if ((keyNames.indexOf(key.Name) > -1) && (!result[key.Name])) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`[Record] adding ${key.Name} = '${key.Value}'`);
                                }
                                if (key.Type == "Date")
                                    result[key.Name] = this.formatDate(key.Value);
                                else
                                    result[key.Name] = key.Value;
                                keysFound++;
                                if (keysFound == keysExpected)
                                    return result;
                            }
                        }
                    }
                    // Just to stop compilation issues
                    return result;
                };
                // This should be obsolete eventually, but needed during conversion to full use of type containers
                this.keyRecordTypesToKeyRecords = (typesList) => {
                    this._log.info("OnBaseHelper.keyRecordTypesToKeyRecords()");
                    let converted = [];
                    typesList.forEach(kwrt => {
                        let rec = {
                            Id: kwrt.Id,
                            Name: kwrt.Name,
                            Type: kwrt.Type,
                            Keywords: this.keyTypeListToKeyList(kwrt.KeywordTypes)
                        };
                        converted.push(rec);
                    });
                    return converted;
                };
                this.keyTypeListToKeyList = (typesList) => {
                    this._log.info("OnBaseHelper.keyTypeListToKeyList()");
                    let converted = [];
                    typesList.forEach(kwt => {
                        converted.push(this.keyTypeToKey(kwt));
                    });
                    return converted;
                };
                // This should be obsolete eventually, but needed during conversion to full use of type containers
                this.keyTypeToKey = (keyType) => {
                    this._log.info("OnBaseHelper.keyTypeToKey()");
                    let converted = {
                        Id: keyType.Id,
                        Name: keyType.Name,
                        Type: keyType.Type,
                        Value: ""
                    };
                    return converted;
                };
                /**
                 *  This is still rather dirty, not sure what our incoming formats might be
                */
                this.formatDate = (dateString) => {
                    this._log.info("OnBaseHelper.formatDate()");
                    let timeSpan = this._core.Functions.getTimezoneCorrectedDateTime(dateString + "T00:00:00").getTime();
                    if (Number.isNaN(timeSpan)) {
                        console.warn("unable to parse date string: " + dateString);
                        return dateString;
                    }
                    else {
                        return this._core.Locale.DateFormatter.format(timeSpan);
                    }
                };
                this.formatDatetime = (datetimetring) => {
                    this._log.info("OnBaseHelper.formatDatetime()");
                    let timeSpan = this._core.Functions.getTimezoneCorrectedDateTime(datetimetring).getTime();
                    if (Number.isNaN(timeSpan)) {
                        console.warn("unable to parse date/time string: " + datetimetring);
                        return datetimetring;
                    }
                    else {
                        return this._core.Locale.DatetimeFormatter.format(timeSpan);
                    }
                };
                this.formatCurrency = (currencyString) => {
                    this._log.info("OnBaseHelper.formatCurrency()");
                    let currency = new Number(currencyString);
                    if (Number.isNaN(currency.valueOf())) {
                        console.warn("unable to parse currency string: " + currencyString);
                        return currencyString;
                    }
                    else {
                        return this._core.Locale.CurrencyFormatter.format(currency.valueOf());
                    }
                };
                this.formatNumber = (numberString) => {
                    this._log.info("OnBaseHelper.formatNumber()");
                    let numberValue = new Number(numberString);
                    if (Number.isNaN(numberValue.valueOf())) {
                        console.warn("unable to parse number string: " + numberString);
                        return numberString;
                    }
                    else {
                        return this._core.Locale.NumberFormatter.format(numberValue.valueOf());
                    }
                };
                this._loadDocTypeAliases = () => {
                    this._log.info("OnBaseHelper._loadDocTypeAliases()");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('DocumentTypeAliasFile') && (appConfig.DocumentTypeAliasFile)) {
                        this._core.Loader.getUnversionedJSON(appConfig.DocumentTypeAliasFile, this._docTypeAliasesResponse);
                    }
                    else {
                        let gwConfig = this._core.Config.getMainConfig();
                        if (gwConfig.hasOwnProperty('DocumentTypeAliasFile') && (gwConfig.DocumentTypeAliasFile)) {
                            this._core.Loader.getUnversionedJSON(gwConfig.DocumentTypeAliasFile, this._docTypeAliasesResponse);
                        }
                        else {
                            this._docTypeAliases = {};
                        }
                    }
                };
                this._docTypeAliasesResponse = (aliasConfig) => {
                    this._log.info("OnBaseHelper._docTypeAliasesResponse()");
                    this._docTypeAliases = aliasConfig;
                    if ('##_DEFAULT_POLICY_##' in this._docTypeAliases) {
                        this._dtAliasDefaultPolicy = this._docTypeAliases['##_DEFAULT_POLICY_##'];
                        delete this._docTypeAliases['##_DEFAULT_POLICY_##'];
                    }
                };
                this.getDocTypeAlias = (originalName, translatedName) => {
                    this._log.info("OnBaseHelper.getDocTypeAlias()");
                    // May need a better response here, such as a callback option
                    if (!this._docTypeAliases) {
                        let message = this._core.Locale.getTranslation('STR_WPT_DOCTYPE_ALIASES_NOT_LOADED');
                        this._core.Helper.presentWarningServiceModal("STR_WPT_CONFIG_CACHE", "STR_WPT_ERROR", message);
                        return translatedName;
                    }
                    // Try the easy option
                    if (originalName in this._docTypeAliases)
                        return this._core.Locale.getTranslation(this._docTypeAliases[originalName]);
                    // null and "" are both falsy
                    if (this._dtAliasDefaultPolicy) {
                        // We need to do the split ourselves, because string.split() is remarkably stupid:
                        // instead of stopping splitting at {limit} it keeps going and throws later segments away.
                        let splitPos = translatedName.indexOf(this._dtAliasDefaultPolicy);
                        if (splitPos != -1) {
                            return translatedName.substring(splitPos + this._dtAliasDefaultPolicy.length).trim();
                        }
                    }
                    // Nothing defined, return original
                    return translatedName;
                };
                // Accepts a list of condition containers, each one may have a list of conditions
                // A return of true indicates at least ONE of the containers evaluated true (so, 'OR')
                // All the conditions in a container must be true to evaluate true (so, 'AND')
                // An empty input list should not alter the default setting, so evaluates false
                // NOTE: Deletes all conditions which are not triggers, so they are only evaluated once.
                // - deletion is possible because ActionPalette widget makes a copy of the task display
                //   conditions when it refreshes.
                this.evaluateActionPaletteConditions = (option, doc = null, obj = null) => {
                    this._log.info("OnBaseHelper.evaluateActionPaletteConditions()");
                    // No conditions - don't alter the default
                    if (!option.hasOwnProperty('DisplayConditions') || (option.DisplayConditions == null) || (option.DisplayConditions.length == 0))
                        return false;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("starting container iteration");
                    }
                    while (option.DisplayConditions.length > 0) {
                        // Setup - state and retention
                        let container = option.DisplayConditions.pop();
                        let containerPassed = true;
                        // Set a default return if we have no conditions set
                        if ((!container.hasOwnProperty('AppliesTo')) || (container.AppliesTo == null)) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("container has no conditions");
                            }
                            container.AppliesTo = [];
                            containerPassed = false;
                        }
                        // Evaluate each condition for this container. All must be true to pass container
                        while (container.AppliesTo.length > 0) {
                            let condition = container.AppliesTo.pop();
                            if (!this._core.Context.evaluateSelectionCriterion(condition, doc, obj)) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("condition evaluated false");
                                }
                                containerPassed = false;
                            }
                        }
                        if (containerPassed) {
                            // Genuine success, not conditional on later triggers - clear conditions and return a pass
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("returning true for option");
                            }
                            option.DisplayConditions = [container];
                            return true;
                        }
                    }
                    // If we get to this point, no containers have passed
                    option.DisplayConditions = [];
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("returning false for option");
                    }
                    return false;
                };
                this.GetObjectAttributeValue = (obj, attrName) => {
                    var _a, _b;
                    this._log.info("OnBaseHelper.GetObjectAttributeValue()");
                    if (!obj)
                        return null;
                    // Process special cases
                    if (attrName == ">>ObjectName") {
                        if (obj.hasOwnProperty('Name'))
                            return obj.Name;
                        else
                            return null;
                    }
                    else if (attrName == ">>ObjectId") {
                        return obj.Id.toString();
                    }
                    // If we got here, we're running against normal attributes - ensure we have an iterable record list
                    if (!obj.hasOwnProperty('Values') || (obj.Values == null))
                        return null;
                    let attr = obj.Values.find(a => a.Name == attrName);
                    // Basic safety checks - I *think* these cover the weird data types too
                    if (!attr || !attr.hasOwnProperty('Value'))
                        return null;
                    // Handle special data types like relations and documents
                    if (attr.DataType == "Relation") {
                        // look for "empty" relation
                        if (!((_a = attr.Relation) === null || _a === void 0 ? void 0 : _a.RelatedId) || attr.Relation.RelatedId == 0) {
                            return null;
                        }
                        return attr.Relation.RelatedId.toString(10);
                    }
                    else if (attr.DataType == "Document") {
                        // look for "empty" document
                        if (!((_b = attr.Document) === null || _b === void 0 ? void 0 : _b.ItemNum)) {
                            return null;
                        }
                        return attr.Document.ItemNum.toString(10);
                    }
                    // All safety checks done
                    return attr.Value;
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("OnBaseHelper::constructor");
                this.ActionHelper = new Utilities.ActionHelper(core);
                this.init();
            }
            // ================================================================================= Keyword Type Caching
            get KeywordTypesLoaded() {
                return this._ccKeywordTypesLoaded && this._ccKeywordRecordTypesLoaded;
            }
            get KeywordTypes() {
                return this._ccKeywordTypes;
            }
            get KeywordTypeNames() {
                return this._ccKeywordTypeNames;
            }
            get KeywordTypeMap() {
                return this._ccKeywordTypeMap;
            }
            get KeywordRecordTypes() {
                return this._ccKeywordRecordTypes;
            }
            get KeywordRecordTypeNames() {
                return this._ccKeywordRecordTypeNames;
            }
            get KeywordRecordTypeMap() {
                return this._ccKeywordRecordTypeMap;
            }
            // ================================================================================= Document Type Caching
            get AllDocumentTypesLoaded() {
                return (this._ccDownloadDocumentTypesLoaded && this._ccUploadDocumentTypesLoaded);
            }
            get DocumentTypesById() {
                return this._ccDocumentTypesById;
            }
            get DownloadDocumentTypesLoaded() {
                return this._ccDownloadDocumentTypesLoaded;
            }
            get UploadDocumentTypesLoaded() {
                return this._ccUploadDocumentTypesLoaded;
            }
            get DownloadDocumentTypes() {
                return this._ccDownloadDocumentTypes;
            }
            get DownloadDocumentTypeMap() {
                return this._ccDownloadDocumentTypeMap;
            }
            get DownloadDocumentTypeNames() {
                return this._ccDownloadDocumentTypeNames;
            }
            get DownloadDocumentTypeGroups() {
                return this._ccDownloadDocumentTypeGroups;
            }
            get DownloadDocumentTypeGroupNames() {
                return this._ccDownloadDocumentTypeGroupNames;
            }
            get UploadDocumentTypes() {
                return this._ccUploadDocumentTypes;
            }
            get UploadDocumentTypeMap() {
                return this._ccUploadDocumentTypeMap;
            }
            get UploadDocumentTypeNames() {
                return this._ccUploadDocumentTypeNames;
            }
            get UploadDocumentTypeGroups() {
                return this._ccUploadDocumentTypeGroups;
            }
            get UploadDocumentTypeGroupNames() {
                return this._ccUploadDocumentTypeGroupNames;
            }
            // ================================================================================= Custom Query Type Caching
            get CustomQueriesLoaded() {
                return this._ccQueriesLoaded;
            }
            get CustomQueries() {
                return this._ccQueries;
            }
            get CustomQueryNames() {
                return this._ccQueryNames;
            }
            get CustomQueryMap() {
                return this._ccQueryMap;
            }
            // ================================================================================= Note Type Caching
            get NoteTypesLoaded() {
                return this._ccNoteTypesLoaded;
            }
            get NoteTypes() {
                return this._ccNoteTypes;
            }
            get NoteTypeNames() {
                return this._ccNoteTypeNames;
            }
            // ================================================================================= Queue Caching
            get QueuesLoaded() {
                return this._ccQueuesLoaded;
            }
            get Queues() {
                return this._ccQueues;
            }
            get QueueActions() {
                return this._ccQueueActions;
            }
            get QueueLifecycles() {
                return this._ccQueueLifecycles;
            }
            // ================================================================================= Keyword Type Caching
            get PseudoSystemTasksLoaded() {
                return this._ccPSysTasksLoaded;
            }
            get PseudoSystemTasks() {
                return this._ccPSysTasks;
            }
            get PseudoSystemTaskMap() {
                return this._ccPSysTaskMap;
            }
            // ================================================================================= WorkView Entities
            get WorkViewLoaded() {
                return this._ccWorkViewLoaded;
            }
            get WorkViewDatasets() {
                return this._ccWVDatasets;
            }
            get WorkViewActions() {
                return this._ccWVActions;
            }
            // ================================================================================= Required Document Types
            get RequiredDocumentsEnabled() {
                return this._rdFunctionsEnabled;
            }
            get RequiredDocumentsDynamicQuerying() {
                return this._rdDynamicMode;
            }
            get RequiredDocumentsLoaded() {
                return this._rdRequiredDocumentsLoaded;
            }
            get RequiredDocumentProfiles() {
                return this._rdProfiles;
            }
        }
        Utilities.OnBaseHelper = OnBaseHelper;
    })(Utilities = WPTNamespace.Utilities || (WPTNamespace.Utilities = {}));
})(WPTNamespace || (WPTNamespace = {}));
